export const dateToTimeStringFormat = (dateValue: Date): string => {
  try {
    return `${String(dateValue.getHours()).padStart(2, "0")}:${String(dateValue.getMinutes()).padStart(2, "0")}`;
  } catch (error) {
    return error.message;
  }
};
